<template lang="pug">
.cms-actions.mt-3(v-nv:scope="navigate_ ? 'cms-actions' : false", @nv-back="$emit('nv-back')")
  pr-button.action-item(style="margin-right: -1px", :small="small", v-show="action.prefix") {{ action.prefix }}
  pr-button.action-item(
    :small="small",
    @nv-enter.native="$emit('cart', data)",
    v-show="action.icon",
    :nv-el="navigate_",
    :class="{ background: navigate_ }"
  )
    icon(:icon="action.icon")
    span.ml-3 {{ action.name }}
</template>

<script>
export default {
  name: "cms-actions",
  filters: {
    addPriceUnit: function(value) {
      if (!value) return ""
      value = value.toString()
      return `${value} ${__.device.config("view_currency.view_currency")}`
    }
  },
  props: ["data", "size", "navigate"],
  computed: {
    navigate_() {
      return typeof this.navigate != "undefined"
    },
    small() {
      return this.size === "small"
    },
    action() {
      switch (this.data.action_type) {
        case "appointment":
          return { icon: "fas calendar-day", name: this.$t(this.small ? "Appointment" : "Make an Appointment") }
        case "reservation":
          return { icon: "fas calendar-day", name: this.$t(this.small ? "Reservation" : "Make a Reservation") }
        case "request":
          return { icon: "fas concierge-bell", name: this.$t(this.small ? "Request" : "Make a Request") }
        case "product":
          return {
            prefix: this.small ? null : this.$options.filters.addPriceUnit(this.data.price),
            icon: "fas shopping-basket",
            name: this.$t(this.small ? this.$options.filters.addPriceUnit(this.data.price) : "Add to Cart")
          }
        default:
          return {}
      }
    }
  },
  async mounted() {
    _$.nav.sync("cms-actions")
  },
  async activated() {
    _$.nav.sync("cms-actions")
  }
}
</script>

<style lang="scss" scoped>
.action-item {
  padding: 0.5em 0.75em !important;
  margin-left: -1px !important;
}
</style>
